<template>
  <div class="my">

    <div class="header_padding">
      <div class="header">
        <img @click="if_info" :src="info.avatar" alt="">
        <div class="header_item" @click="if_info">
          <div class="header_item_info" v-if="$store.state.token" >
            <p>{{ info.phoneNo }}</p>
            <p>编辑个人信息</p>
          </div>
          <p v-else @click="if_info" class="header_item_login">点击登录</p>
          <i @click="if_info" class="iconfont icon-tiaozhuan"></i>
        </div>
      </div>

      <div class="order">
<!--        <div class="order_title" @click="orderLink('/OrderList','')">-->
<!--          <h2>订单</h2>-->
<!--          <i class="iconfont icon-tiaozhuan"></i>-->
<!--        </div>-->
        <ul class="order_deta">
<!--          @click="orderLink('/OrderList','0')"-->
          <li @click="link('/OrderList')">
            <img src="../../assets/My/left.png" alt="">
<!--            <p>待付款</p>-->
            <p>订单</p>
          </li>
<!--          @click="orderLink('/OrderList','1')"-->
          <li @click="link('/MakeList')">
            <img src="../../assets/My/right.png" alt="">
<!--            <p>待服务</p>-->
            <p>预约</p>
          </li>
        </ul>
      </div>
    </div>

    <ul class="my_list">
      <li @click="link('/MyReportList')">
        <div class="my_list_left">
          <img src="../../assets/My/icon1.png" alt="">
          <p>报告管理</p>
        </div>
        <i class="iconfont icon-tiaozhuan"></i>
      </li>
      <li @click="link('/infoList')">
        <div class="my_list_left">
          <img src="../../assets/My/icon2.png" alt="">
          <p>就诊人信息</p>
        </div>
        <i class="iconfont icon-tiaozhuan"></i>
      </li>
<!--      <li @click="link('/MakeList')">-->
<!--        <div class="my_list_left">-->
<!--          <img src="../../assets/My/icon3.png" alt="">-->
<!--          <p>我的预约</p>-->
<!--        </div>-->
<!--        <i class="iconfont icon-tiaozhuan"></i>-->
<!--      </li>-->
<!--      <li @click="link('/About')">-->
<!--        <div class="my_list_left">-->
<!--          <img src="../../assets/My/icon4.png" alt="">-->
<!--          <p>关于我们</p>-->
<!--        </div>-->
<!--        <i class="iconfont icon-tiaozhuan"></i>-->
<!--      </li>-->
    </ul>


    <div class="loginout" v-if="$store.state.token != null" >
      <mu-button @click="show = true" round >退出</mu-button>
    </div>

    <van-popup v-model="show">
      <div class="popup">
        <img src="../../assets/My/head.png" alt="">
        <p>是否退出当前账户？</p>
        <div class="popup_button">
          <mu-button @click="show = false" round >取消</mu-button>
          <mu-button @click="login_out" round >确认</mu-button>
        </div>
      </div>
    </van-popup>

  </div>
</template>

<script>
import headers from "../../assets/My/head.png";
export default {
  name: "My",
  data() {
    return{
      show: false,
      // 用户信息
      info: {
        avatar: headers,
        phoneNo: null,
      },
    }
  },
  created() {

    this.$isIos();
    if(this.$store.state.token) {
      this.getInfo();
    }

  },
  mounted() {

  },
  methods: {
    getInfo() {
      this.$get("user/basic")
        .then(res => {
          if(res) {
            console.log(res)
            this.$store.commit("setPhoneNo",res.data.phoneNo);
            if(res.data) {
              this.info= res.data;
            }

          }
        })
    },
    // 订单
    orderLink(e,y) {
        this.$router.push({
          path: e,
          query: {
            active: y
          }
        })
    },
    // 列表
    link(e) {
      this.$router.push({
        path: e
      })
    },
    // 信息
    if_info() {

      if(this.$store.state.token) {

        this.$router.push({
          path: "/infoDeta",
          query: {
            phoneNo: this.info.phoneNo
          }
        })

      }else {
        this.$auth();
      }

    },
    // 退出
    login_out() {
      this.$post("login/quit")
        .then(res => {
          console.log(res);
          this.$store.commit("setToken",null);
          this.show= false;

          this.info.avatar = headers;
          this.info.phoneNo = null;

        })
    }
  }
}
</script>

<style lang="less" scoped>
  @import "../../style/Nav/My";
</style>
